export const listReport = {
  table: {
    date: 'Date',
    total: 'Total',
    inquiry: 'Inquiry',
    export: 'Export',
    hour: '(unit　ｈ)',
    id: 'ID',
    fullName: 'Name',
  },
  pageHeader: {
    title: 'Individual productivity management',
  },
  filter: {
    filterDay: 'View by date',
    filterByRangeDay: 'View by range date',
    filterByTime: 'View by specifying period',
    filterEmployee: 'Filter by employee',
    note: '※If you select not specified, the amount of data will be large. \n Please make inquiries within one week.',
    defaultValue: 'No data',
    gender: 'Gender',
    position: 'Position',
    department: 'Department',
  },
  hooks: {
    selectRangeDateFail: 'Range date invalid',
  },
}
